import api from './api';

export const getUserFromId = async params => {
  const { id } = params;
  try {
    const { data } = await api.get(`usuario?id=${id}`);
    return { data };
  } catch (error) {
    return { error };
  }
};

export const putEditProfileUser = async params => {
  const { payload } = params;
  try {
    const { data } = await api.put('/Usuario/editarPerfil', payload);
    return { data };
  } catch (error) {
    return { error };
  }
};

export const patchEditePassword = async params => {
  const { payload } = params;
  try {
    const { data, status } = await api.patch('/Usuario/alterarSenha', {
      ...payload,
    });

    return { data, status };
  } catch (error) {
    return { error };
  }
};
